// Port of api/fuel/app/classes/filter/data/games.php
import DB from 'offline/db'
import Util from 'offline/util'
import Constants from 'offline/constants'
import F from 'offline/filter/constants'

function pushUniqueGame(games, seen, game) {
	if (!game || !game.id || seen[game.id]) return
	games.push({ id: game.id, name: game.name })
	seen[game.id] = true
}

function pushUniqueUser(users, seen, user) {
	if (!user || !user.id || seen[user.id]) return
	users.push(user)
	seen[user.id] = true
}

function resultContexts(resultType) {
	var contexts = [Constants.TAG_CONTEXT_GAME]
	if (resultType === F.RESULT_COLLECTION) contexts.push(Constants.TAG_CONTEXT_COLLECTION)
	if (resultType === F.RESULT_RATING) contexts.push(Constants.TAG_CONTEXT_RATING)
	if (resultType === F.RESULT_PLAY) contexts.push(Constants.TAG_CONTEXT_PLAY)
	if (resultType === F.RESULT_GAME) contexts.push(Constants.TAG_CONTEXT_GAMEPLAY)
	return contexts
}

function buildContains(config, filter, packageItems) {
	var enabled = config &&
		config.settings &&
		config.settings.session &&
		config.settings.session.collection &&
		config.settings.session.collection.contains

	if (!enabled) return []
	if (config.resultType !== F.RESULT_COLLECTION && config.resultType !== F.RESULT_GAME) return []

	var containIndex = []
	for (var i = 0; i < (packageItems || []).length; i++) {
		var item = packageItems[i]
		var contains = item && item.game ? item.game.contains : []
		if (contains && contains.length) containIndex = containIndex.concat(contains)
	}

	containIndex = Array.from(new Set(containIndex.filter(function(id) { return !!id })))
	if (!containIndex.length) return []

	var Package = require('offline/filter/core/package').default
	var configCopy = Object.assign({}, config, {
		filterType: F.TYPE_GAMES,
		resultType: F.RESULT_GAME,
		cacheType: F.CACHE_INLINE,
		pseudoType: F.PSEUDO_GAME,
		packageType: [F.PACKAGE_GAME]
	})

	var packaged = Package.run(configCopy, filter, {
		total: containIndex.length,
		pseudo: 0,
		games: containIndex,
		users: [config.owner.get_id()],
		results: containIndex,
		context: {}
	})

	return packaged[0] || []
}

export default {
	run: function(config, filter, packageItems, data) {
		var result = {
			games: [],
			designers: [],
			publishers: [],
			artists: [],
			mechanics: [],
			categories: [],
			families: [],
			languages: [],
			subdomains: [],
			users: [],
			tags: [],
			tagFamilies: [],
			views: [],
			nested: data && data.nested ? data.nested : [],
			contains: data && data.contains ? data.contains : []
		}

		var gameSeen = {}
		var userSeen = {}
		var userIds = data && data.users ? data.users.slice() : []
		var packageData = packageItems || []
		var nestedItems = (data && data.nested) || []
		var i

		for (i = 0; i < packageData.length; i++) {
			var item = packageData[i]
			pushUniqueGame(result.games, gameSeen, item.game)
		}

		for (i = 0; i < nestedItems.length; i++) {
			pushUniqueGame(result.games, gameSeen, nestedItems[i].game)
		}

		if (!result.contains.length) {
			result.contains = buildContains(config, filter, packageItems)
		}

		if (config.page === 1) {
			var filterGroups = ['designers', 'languages', 'families', 'publishers', 'artists', 'mechanics', 'subdomains', 'categories']
			for (i = 0; i < filterGroups.length; i++) {
				var key = filterGroups[i]
				if (filter[key] && filter[key].length) {
					var ids = Util.abs(filter[key])
					var table = key.slice(0, -1)
					if (key === 'families') table = 'family'
					if (key === 'categories') table = 'category'
					if (key === 'subdomains') table = 'subdomain'
					var rows = DB.queryFast('SELECT * FROM ' + table + ' WHERE ' + table + '_id IN(' + Util.in(ids) + ')')
					result[key] = rows.map(function(row) {
						return {
							id: row[table + '_id'],
							name: row[table + '_name']
						}
					})
				}
			}

			if (filter.games) {
				var gameFilterKeys = ['include', 'exclude', 'subset']
				var extraGameIds = []
				for (i = 0; i < gameFilterKeys.length; i++) {
					if (filter.games[gameFilterKeys[i]] && filter.games[gameFilterKeys[i]].length) {
						extraGameIds = extraGameIds.concat(filter.games[gameFilterKeys[i]])
					}
				}
				extraGameIds = Array.from(new Set(extraGameIds))
				if (extraGameIds.length) {
					var extraGames = DB.queryFast('SELECT game_id, game_name FROM game WHERE game_id IN(' + Util.in(extraGameIds) + ')')
					for (i = 0; i < extraGames.length; i++) {
						pushUniqueGame(result.games, gameSeen, { id: extraGames[i].game_id, name: extraGames[i].game_name })
					}
				}
			}

			if (filter.users && filter.users.length) {
				userIds = userIds.concat(filter.users)
			}

			if (config.filterType === 1 && config.ownerType === 1) {
				var contexts = resultContexts(config.resultType)
				var tagWhere = 'user_id = ? AND tag_context IN(' + Util.in(contexts) + ')'
				var tagParams = [config.owner.get_id()]
				if (config.sessionID !== config.owner.get_id()) tagWhere += ' AND tag_public = 1'
				result.tags = DB.query('SELECT tag_id AS id, family_id AS family, tag_context AS context, tag_public AS public, tag_text AS text, tag_colour AS colour, tag_fore AS fore, tag_attachments AS attachments FROM tag WHERE ' + tagWhere + ' ORDER BY tag_text ASC', tagParams)

				var familyWhere = 'user_id = ? AND family_context IN(' + Util.in(contexts) + ')'
				var familyParams = [config.owner.get_id()]
				if (config.sessionID !== config.owner.get_id()) familyWhere += ' AND family_public = 1'
				result.tagFamilies = DB.query('SELECT family_id AS id, family_type AS type, family_context AS context, family_public AS public, family_style AS style, family_name AS name, family_colour AS colour, family_fore AS fore, family_attachments AS attachments FROM tag_family WHERE ' + familyWhere + ' ORDER BY family_name ASC', familyParams)

				var viewWhere = 'user_id = ? AND view_context IN(' + Util.in(contexts) + ')'
				var viewParams = [config.owner.get_id()]
				if (config.sessionID !== config.owner.get_id()) viewWhere += ' AND view_public = 1'
				var viewRows = DB.query('SELECT view_id, view_default, view_type, view_context, view_public, view_name, view_fields FROM view WHERE ' + viewWhere + ' ORDER BY view_name ASC', viewParams)
				result.views = viewRows.map(function(row) {
					return {
						id: row.view_id,
						default: row.view_default,
						type: row.view_type,
						context: row.view_context,
						public: row.view_public,
						name: row.view_name,
						fields: typeof row.view_fields === 'string' ? JSON.parse(row.view_fields || '[]') : (row.view_fields || [])
					}
				})
			}
		}

		for (i = 0; i < packageData.length; i++) {
			var pkg = packageData[i]
			var users = pkg.users || {}
			userIds = userIds
				.concat(Object.keys(users.played || {}).map(function(id) { return parseInt(id, 10) }))
				.concat(Object.keys(users.rated || {}).map(function(id) { return parseInt(id, 10) }))
				.concat((users.status && users.status.fortrade) || [])
				.concat((users.status && users.status.hasparts) || [])
				.concat((users.status && users.status.own) || [])
				.concat((users.status && users.status.preordered) || [])
				.concat((users.status && users.status.prevowned) || [])
				.concat((users.status && users.status.want) || [])
				.concat((users.status && users.status.wanttobuy) || [])
				.concat((users.status && users.status.wantparts) || [])
				.concat((users.status && users.status.wanttoplay) || [])
				.concat((users.status && users.status.wishlist) || [])
		}

		var knownUsers = config && config.knownUsers ? config.knownUsers : []
		userIds = Array.from(new Set(userIds.filter(function(id) { return !!id }))).filter(function(id) {
			return knownUsers.indexOf(id) === -1
		})
		if (userIds.length) {
			var usersRows = DB.queryFast('SELECT user_id, user_name, user_firstname, user_lastname, user_sortname, user_country, user_avatar FROM user WHERE user_id IN(' + Util.in(userIds) + ')')
			for (i = 0; i < usersRows.length; i++) {
				var u = usersRows[i]
				pushUniqueUser(result.users, userSeen, {
					id: u.user_id,
					name: u.user_name,
					fullname: [u.user_firstname || '', u.user_lastname || ''].join(' ').trim(),
					sortname: u.user_sortname || '',
					country: u.user_country || 0,
					slug: encodeURIComponent(u.user_name || '').replace(/\+/g, ' '),
					avatar: u.user_avatar || ''
				})
			}
		}

		if (result.games.length && config.ownerType === F.OWNER_USER) {
			var gameIds = Util.pluck(result.games, 'id')
			var renameWhere = 'user_id = ? AND game_id IN(' + Util.in(gameIds) + ')'
			var renameParams = [config.owner.get_id()]
			if (config.sessionID !== config.owner.get_id()) renameWhere += ' AND custom_rename_public = 1'

			var renameRows = DB.query(
				'SELECT game_id, custom_rename_text FROM custom_rename WHERE ' + renameWhere,
				renameParams
			)
			var renameLookup = {}
			for (i = 0; i < renameRows.length; i++) {
				renameLookup[renameRows[i].game_id] = renameRows[i].custom_rename_text
			}

			for (i = 0; i < result.games.length; i++) {
				if (renameLookup[result.games[i].id]) {
					result.games[i].name = renameLookup[result.games[i].id]
				}
			}
		}

		return result
	}
}
